export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Skapa bild med hjälp av AI',
        requestFailed: 'Begäran misslyckades',
        describeYourImage: 'Beskriv din bild',
        numberOfVariations: 'Antal variationer',
        chooseStyle: 'Välj din bildstil',
        descriptionPlaceholder: '(eg) En åker med senapsblommor på en sommardag med ekträd',
        clear: 'Klar',
        generate: 'Generera',
        seeAll: 'Se alla',
        tryAnExample: 'Prova ett exempel',
        tryAnother: 'Prova en annan',
    },
};
